import EmptyView from 'components/EmptyView';

export default function RatingsView() {
  return <EmptyView />;
}
